import setSubmitsBlock from 'root/src/client/logic/form/actions/setSubmitsBlock'

export default ({ moduleId, isVisible }) => dispatch => dispatch(
	setSubmitsBlock({ moduleId, isVisible }),
)
